// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"nq-z","breadcrumbForward":"oq-z","breadcrumbBack":"pq-z","selected":"qq-z"};